module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedItem panel bg-lightest black pb-0 px-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mx-5 d-flex flex-columns justify-content-between mt-3 pb-3 border-bottom-light"
  }, [_c('v-select', {
    staticClass: "pr-2",
    attrs: {
      "label": "name",
      "placeholder": "Products",
      "options": _vm.products
    },
    model: {
      value: (_vm.selectedProduct),
      callback: function($$v) {
        _vm.selectedProduct = $$v
      },
      expression: "selectedProduct"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "name",
      "placeholder": "Time",
      "options": _vm.hours
    },
    model: {
      value: (_vm.selectedHour),
      callback: function($$v) {
        _vm.selectedHour = $$v
      },
      expression: "selectedHour"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mx-5 search mt-3 d-flex flex-row justify-content-between"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "m-0 p-0 col",
    attrs: {
      "type": "text",
      "placeholder": "Search for ticket or customer…"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "ico-search larger color-1 m-0 p-0 pl-2 col-sm-auto"
  })]), _vm._v(" "), _c('div', {
    staticClass: "px-5 pt-4 d-flex h-100"
  }, [_c('list', {
    staticClass: "w-100 missingCheckinsList",
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.filteredList,
      "actions": _vm.actions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "color-6 text-center p-2 mt-2 border-light font-weight-600 pointer"
  }, [_c('router-link', {
    staticClass: "color-6",
    attrs: {
      "to": {
        name: 'reservations'
      }
    }
  }, [_vm._v("Go to reservations list")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 px-5 font-weight-600"
  }, [_c('span', {
    staticClass: "ml-1"
  }, [_vm._v("Missing Check-ins")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5a12d1e3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a12d1e3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedcardMissedcheckins.vue
// module id = 1517
// module chunks = 0